import React from 'react';
import { PossibleImageSizes, DisplayPronouns } from '@axiom/const';
import type { Candidate } from '@axiom/validation';
import { CandidateYearsOfExperienceModel } from '@axiom/ui-models';
import {
  CandidateBadges,
  CandidateProfileUtil,
  CondensedMedium,
  Gutter,
  ImageCircle,
  Layout,
  LayoutItem,
  Paragraph,
  SmallHeader,
  useBreakpoint,
} from '@axiom/ui';

export type ProfileClientViewCandidateCardHeader = {
  candidate: Candidate;
  name?: string;
};

export const ProfileClientViewCandidateCardHeader = ({
  candidate,
  name = 'PROFILE_CLIENT_VIEW_CANDIDATE_HEADER',
}: ProfileClientViewCandidateCardHeader) => {
  const { isMobile } = useBreakpoint();
  return (
    <Layout
      position={isMobile ? 'left' : 'middle'}
      horizontalGutter="16px"
      name={name}
      direction={isMobile ? 'vertical' : 'horizontal'}
    >
      <LayoutItem>
        <ImageCircle
          name="PROFILE_CLIENT_VIEW_CANDIDATE_IMAGE"
          imageName={candidate.calculatedDisplayName}
          src={CandidateProfileUtil.getProfileImageUri(
            candidate,
            PossibleImageSizes.W_100
          )}
        />
        <Gutter bottom="16px" only="mobile" />
      </LayoutItem>
      <LayoutItem fluid>
        <Layout position="middle" horizontalGutter="8px">
          <LayoutItem>
            <SmallHeader name="PROFILE_CLIENT_VIEW_DISPLAY_NAME">
              {candidate.calculatedDisplayName}
            </SmallHeader>
          </LayoutItem>
          <LayoutItem fluid>
            {candidate.pronouns ? (
              <Paragraph name="PROFILE_CLIENT_VIEW_PRONOUNS">
                {DisplayPronouns[candidate.pronouns]}
              </Paragraph>
            ) : null}
          </LayoutItem>
        </Layout>
        {candidate.yearsOfExperience !== null &&
          Number.isInteger(candidate.yearsOfExperience) &&
          candidate.yearsOfExperience >= 0 && (
            <CondensedMedium name="PROFILE_CLIENT_VIEW_YEARS_OF_EXPERIENCE">
              {`${new CandidateYearsOfExperienceModel(
                candidate.yearsOfExperience
              ).getYearsOfExperienceRange()} years experience`}
            </CondensedMedium>
          )}
        <Gutter bottom="8px" />
        <CandidateBadges badges={candidate.badges} />
        <Gutter bottom="16px" only="mobile" />
      </LayoutItem>
    </Layout>
  );
};
